// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --bs-body-font-size: 1.1rem;
}

/* For Firefox */
html {
    scrollbar-color: var(--md-sys-color-primary);
    /*scrollbar-width: thin;*/
}

/* For Chrome, Edge, and Safari */
body::-webkit-scrollbar {
    width: 10px;
}

body::-webkit-scrollbar-track {
    background-color: transparent;
}

body::-webkit-scrollbar-thumb {
    background-color: var(--md-sys-color-primary);
}

/* For horizontal scrolling */
.tabbed-navigation {
    overflow-x: auto;
}

.tabbed-navigation::-webkit-scrollbar {
    height: 6px;
    width: 6px;
}

.tabbed-navigation::-webkit-scrollbar-track {
    background-color: transparent;
}

.tabbed-navigation::-webkit-scrollbar-thumb {
    background-color: var(--md-sys-color-primary);
}

a {
    color: var(--md-sys-color-on-surface-variant);
}

a, a:hover {
    text-decoration: none
}

a:hover {
    color: var(--md-sys-color-on-surface);
}

.link-no-style:hover {
    text-decoration: none;
    color: var(--md-sys-color-on-surface-variant)
}

.dropdown-item {
    font-family: 'ProductSans-Small', Arial, Helvetica, sans-serif;
}

p, a, li {
    font-family: 'ProductSans-Small', Arial, Helvetica, sans-serif;
}

.nav-item a, .tab-label {
    font-family: 'ProductSans-Medium', Arial, Helvetica, sans-serif;
}

section {
    padding-right: 3rem;
    padding-left: 3rem;
}

ul > li {
    margin-bottom: 13px;
}

.btn {
    padding: 0.7rem 1.2rem;
    border-radius: 20px;
    font-family: 'ProductSans-Bold', Arial, Helvetica, sans-serif;
}

.btn-landing {
    color: var(--md-sys-color-landing-btn);
    background-color: var(--md-sys-color-landing-btn-background);
    border: 2px solid var(--md-sys-color-landing-btn-background);
}

.btn-landing:not(:hover) {
    transition-duration: 0.4s;
}

.btn-landing:hover, .btn-landing:focus, .btn-landing.focus {
    color: var(--md-sys-color-landing-btn);
    background-color: var(--md-sys-color-landing-btn-background);
    border: 2px solid var(--md-sys-color-landing-btn);
    transition-duration: 0.6s;
}

.btn-primary {
    color: var(--md-sys-color-on-primary);
    background-color: var(--md-sys-color-primary);
    border: 2px solid var(--md-sys-color-primary);
}

.btn-primary:not(:hover) {
    transition-duration: 0.4s;
}

.btn-primary:hover, .btn-primary:focus, .btn-primary.focus {
    color: var(--md-sys-color-on-primary);
    background-color: var(--md-sys-color-primary);
    border: 2px solid var(--md-sys-color-on-primary);
    transition-duration: 0.6s;
}

.btn-secondary {
    color: var(--md-ref-palette-secondary30);
    background-color: var(--md-ref-palette-secondary90);
    border: 2px solid var(--md-ref-palette-secondary90);
}


.btn-secondary:not(:hover) {
    transition-duration: 0.4s;
}

.btn-secondary:hover, .btn-secondary:focus, .btn-secondary.focus {
    color: var(--md-ref-palette-secondary30);
    background-color: var(--md-ref-palette-secondary90);
    border: 2px solid var(--md-ref-palette-secondary30);
    transition-duration: 0.6s;
}


.btn-tertiary {
    color: var(--md-ref-palette-tertiary30);
    background-color: var(--md-ref-palette-tertiary90);
    border: 2px solid var(--md-ref-palette-tertiary90);
}

.btn-tertiary:not(:hover) {
    transition-duration: 0.4s;
}

.btn-tertiary:hover, .btn-tertiary:focus, .btn-tertiary.focus {
    color: var(--md-ref-palette-tertiary30);
    background-color: var(--md-ref-palette-tertiary90);
    border: 2px solid var(--md-ref-palette-tertiary30);
    transition-duration: 0.6s;
}


.btn-neutral {
    color: var(--md-ref-palette-neutral30);
    background-color: var(--md-ref-palette-neutral90);
    border: 2px solid var(--md-ref-palette-neutral30);
    border-radius: 15px;
    font-weight: 600;
}

.btn-neutral:not(:hover) {
    transition-duration: 0.4s;
}

.btn-neutral:hover, .btn-neutral:focus, .btn-neutral.focus {
    color: var(--md-ref-palette-neutral30);
    background-color: var(--md-ref-palette-neutral90);
    border: 2px solid var(--md-ref-palette-neutral30);
    transition-duration: 0.6s;
}

.display-large {
    font-family: var(--md-sys-typescale-display-large-font-family-name);
    font-style: var(--md-sys-typescale-display-large-font-family-style);
    font-weight: var(--md-sys-typescale-display-large-font-weight);
    font-size: var(--md-sys-typescale-display-large-font-size);
    letter-spacing: var(--md-sys-typescale-display-large-letter-spacing);
    line-height: var(--md-sys-typescale-display-large-line-height);
}

.display-medium {
    font-family: var(--md-sys-typescale-display-medium-font-family-name);
    font-style: var(--md-sys-typescale-display-medium-font-family-style);
    font-weight: var(--md-sys-typescale-display-medium-font-weight);
    font-size: var(--md-sys-typescale-display-medium-font-size);
    letter-spacing: var(--md-sys-typescale-display-medium-letter-spacing);
    line-height: var(--md-sys-typescale-display-medium-line-height);
}

.display-small {
    font-family: var(--md-sys-typescale-display-small-font-family-name);
    font-style: var(--md-sys-typescale-display-small-font-family-style);
    font-weight: var(--md-sys-typescale-display-small-font-weight);
    font-size: var(--md-sys-typescale-display-small-font-size);
    letter-spacing: var(--md-sys-typescale-display-small-letter-spacing);
    line-height: var(--md-sys-typescale-display-small-line-height);
}

.headline-large {
    font-family: var(--md-sys-typescale-headline-large-font-family-name);
    font-style: var(--md-sys-typescale-headline-large-font-family-style);
    font-weight: var(--md-sys-typescale-headline-large-font-weight);
    font-size: var(--md-sys-typescale-headline-large-font-size);
    letter-spacing: var(--md-sys-typescale-headline-large-letter-spacing);
    line-height: var(--md-sys-typescale-headline-large-line-height);
}

.headline-medium {
    font-family: var(--md-sys-typescale-headline-medium-font-family-name);
    font-style: var(--md-sys-typescale-headline-medium-font-family-style);
    font-weight: var(--md-sys-typescale-headline-medium-font-weight);
    font-size: var(--md-sys-typescale-headline-medium-font-size);
    letter-spacing: var(--md-sys-typescale-headline-medium-letter-spacing);
    line-height: var(--md-sys-typescale-headline-medium-line-height);
}

.headline-small {
    font-family: var(--md-sys-typescale-headline-small-font-family-name);
    font-style: var(--md-sys-typescale-headline-small-font-family-style);
    font-weight: var(--md-sys-typescale-headline-small-font-weight);
    font-size: var(--md-sys-typescale-headline-small-font-size);
    letter-spacing: var(--md-sys-typescale-headline-small-letter-spacing);
    line-height: var(--md-sys-typescale-headline-small-line-height);
}

.body-large {
    font-family: var(--md-sys-typescale-body-large-font-family-name);
    font-style: var(--md-sys-typescale-body-large-font-family-style);
    font-weight: var(--md-sys-typescale-body-large-font-weight);
    font-size: var(--md-sys-typescale-body-large-font-size);
    letter-spacing: var(--md-sys-typescale-body-large-letter-spacing);
    line-height: var(--md-sys-typescale-body-large-line-height);
}

.body-medium {
    font-family: var(--md-sys-typescale-body-medium-font-family-name);
    font-style: var(--md-sys-typescale-body-medium-font-family-style);
    font-weight: var(--md-sys-typescale-body-medium-font-weight);
    font-size: var(--md-sys-typescale-body-medium-font-size);
    letter-spacing: var(--md-sys-typescale-body-medium-letter-spacing);
    line-height: var(--md-sys-typescale-body-medium-line-height);
}

.body-small {
    font-family: var(--md-sys-typescale-body-small-font-family-name);
    font-style: var(--md-sys-typescale-body-small-font-family-style);
    font-weight: var(--md-sys-typescale-body-small-font-weight);
    font-size: var(--md-sys-typescale-body-small-font-size);
    letter-spacing: var(--md-sys-typescale-body-small-letter-spacing);
    line-height: var(--md-sys-typescale-body-small-line-height);
}

.label-large {
    font-family: var(--md-sys-typescale-label-large-font-family-name);
    font-style: var(--md-sys-typescale-label-large-font-family-style);
    font-weight: var(--md-sys-typescale-label-large-font-weight);
    font-size: var(--md-sys-typescale-label-large-font-size);
    letter-spacing: var(--md-sys-typescale-label-large-letter-spacing);
    line-height: var(--md-sys-typescale-label-large-line-height);
}

.label-medium {
    font-family: var(--md-sys-typescale-label-medium-font-family-name);
    font-style: var(--md-sys-typescale-label-medium-font-family-style);
    font-weight: var(--md-sys-typescale-label-medium-font-weight);
    font-size: var(--md-sys-typescale-label-medium-font-size);
    letter-spacing: var(--md-sys-typescale-label-medium-letter-spacing);
    line-height: var(--md-sys-typescale-label-medium-line-height);
}

.label-small {
    font-family: var(--md-sys-typescale-label-small-font-family-name);
    font-style: var(--md-sys-typescale-label-small-font-family-style);
    font-weight: var(--md-sys-typescale-label-small-font-weight);
    font-size: var(--md-sys-typescale-label-small-font-size);
    letter-spacing: var(--md-sys-typescale-label-small-letter-spacing);
    line-height: var(--md-sys-typescale-label-small-line-height);
}

.title-large {
    font-family: var(--md-sys-typescale-title-large-font-family-name);
    font-style: var(--md-sys-typescale-title-large-font-family-style);
    font-weight: var(--md-sys-typescale-title-large-font-weight);
    font-size: var(--md-sys-typescale-title-large-font-size);
    letter-spacing: var(--md-sys-typescale-title-large-letter-spacing);
    line-height: var(--md-sys-typescale-title-large-line-height);
}

.title-medium {
    font-family: var(--md-sys-typescale-title-medium-font-family-name);
    font-style: var(--md-sys-typescale-title-medium-font-family-style);
    font-weight: var(--md-sys-typescale-title-medium-font-weight);
    font-size: var(--md-sys-typescale-title-medium-font-size);
    letter-spacing: var(--md-sys-typescale-title-medium-letter-spacing);
    line-height: var(--md-sys-typescale-title-medium-line-height);
}

.title-small {
    font-family: var(--md-sys-typescale-title-small-font-family-name);
    font-style: var(--md-sys-typescale-title-small-font-family-style);
    font-weight: var(--md-sys-typescale-title-small-font-weight);
    font-size: var(--md-sys-typescale-title-small-font-size);
    letter-spacing: var(--md-sys-typescale-title-small-letter-spacing);
    line-height: var(--md-sys-typescale-title-small-line-height);
}

.primary {
    background-color: var(--md-sys-color-primary);
}

.primary-text {
    color: var(--md-sys-color-primary);
}

.on-primary {
    background-color: var(--md-sys-color-on-primary);
}

.on-primary-text {
    color: var(--md-sys-color-on-primary);
}

.primary-container {
    background-color: var(--md-sys-color-primary-container);
}

.primary-container-text {
    color: var(--md-sys-color-primary-container);
}

.on-primary-container {
    background-color: var(--md-sys-color-on-primary-container);
}

.on-primary-container-text {
    color: var(--md-sys-color-on-primary-container);
}

.secondary {
    background-color: var(--md-sys-color-secondary);
}

.secondary-text {
    color: var(--md-sys-color-secondary);
}

.on-secondary {
    background-color: var(--md-sys-color-on-secondary);
}

.on-secondary-text {
    color: var(--md-sys-color-on-secondary);
}

.secondary-container {
    background-color: var(--md-sys-color-secondary-container);
}

.secondary-container-text {
    color: var(--md-sys-color-secondary-container);
}

.on-secondary-container {
    background-color: var(--md-sys-color-on-secondary-container);
}

.on-secondary-container-text {
    color: var(--md-sys-color-on-secondary-container);
}

.tertiary {
    background-color: var(--md-sys-color-tertiary);
}

.tertiary-text {
    color: var(--md-sys-color-tertiary);
}

.on-tertiary {
    background-color: var(--md-sys-color-on-tertiary);
}

.on-tertiary-text {
    color: var(--md-sys-color-on-tertiary);
}

.tertiary-container {
    background-color: var(--md-sys-color-tertiary-container);
}

.tertiary-container-text {
    color: var(--md-sys-color-tertiary-container);
}

.on-tertiary-container {
    background-color: var(--md-sys-color-on-tertiary-container);
}

.on-tertiary-container-text {
    color: var(--md-sys-color-on-tertiary-container);
}

.error {
    background-color: var(--md-sys-color-error);
}

.error-text {
    color: var(--md-sys-color-error);
}

.error-container {
    background-color: var(--md-sys-color-error-container);
}

.error-container-text {
    color: var(--md-sys-color-error-container);
}

.on-error {
    background-color: var(--md-sys-color-on-error);
}

.on-error-text {
    color: var(--md-sys-color-on-error);
}

.on-error-container {
    background-color: var(--md-sys-color-on-error-container);
}

.on-error-container-text {
    color: var(--md-sys-color-on-error-container);
}

.background {
    background-color: var(--md-sys-color-background);
}

.background-text {
    color: var(--md-sys-color-background);
}

.on-background {
    background-color: var(--md-sys-color-on-background);
}

.on-background-text {
    color: var(--md-sys-color-on-background);
}

.surface {
    background-color: var(--md-sys-color-surface);
}

.surface-text {
    color: var(--md-sys-color-surface);
}

.on-surface {
    background-color: var(--md-sys-color-on-surface);
}

.on-surface-text {
    color: var(--md-sys-color-on-surface);
}

.surface-variant {
    background-color: var(--md-sys-color-surface-variant);
}

.surface-variant-text {
    color: var(--md-sys-color-surface-variant);
}

.on-surface-variant {
    background-color: var(--md-sys-color-on-surface-variant);
}

.on-surface-variant-text {
    color: var(--md-sys-color-on-surface-variant);
}

.outline {
    background-color: var(--md-sys-color-outline);
}

.outline-text {
    color: var(--md-sys-color-outline);
}

.inverse-on-surface {
    background-color: var(--md-sys-color-inverse-on-surface);
}

.inverse-on-surface-text {
    color: var(--md-sys-color-inverse-on-surface);
}

.inverse-surface {
    background-color: var(--md-sys-color-inverse-surface);
}

.inverse-surface-text {
    color: var(--md-sys-color-inverse-surface);
}

.inverse-primary {
    background-color: var(--md-sys-color-inverse-primary);
}

.inverse-primary-text {
    color: var(--md-sys-color-inverse-primary);
}

.shadow {
    background-color: var(--md-sys-color-shadow);
}

.shadow-text {
    color: var(--md-sys-color-shadow);
}

.surface-tint {
    background-color: var(--md-sys-color-surface-tint);
}

.surface-tint-text {
    color: var(--md-sys-color-surface-tint);
}

.outline-variant {
    background-color: var(--md-sys-color-outline-variant);
}

.outline-variant-text {
    color: var(--md-sys-color-outline-variant);
}

.scrim {
    background-color: var(--md-sys-color-scrim);
}

.scrim-text {
    color: var(--md-sys-color-scrim);
}

:is(.text-field) {
    line-height: var(--md-sys-typescale-body-large-line-height);
    letter-spacing: var(--md-sys-typescale-body-large-letter-spacing);
    font-size: var(--md-sys-typescale-body-large-font-size);
    font-weight: var(--md-sys-typescale-body-large-font-weight);
    font-family: var(--md-sys-typescale-body-large-font-family-name);
    position: relative;
    display: inline-block;
    overflow: hidden;
}


:where(input, textarea):not(:focus)::placeholder {
    color: transparent;
}

.text-field:is(:focus)::placeholder {
    color: grey;
}

:is(.text-field).filled > :where(input, textarea) {

    display: block;
    box-sizing: border-box;
    margin: 0px;
    border-right: none;
    border-left: none;
    border-image: initial;
    border-top: 27px solid transparent;
    border-bottom: solid 1px var(--md-sys-color-primary);
    border-radius: 4px 4px 0px 0px;
    padding: 0px 12px 10px;
    width: 100%;
    height: inherit;
    color: rgb(var(--md-sys-color-surface-tint) / 0.87);
    background-color: var(--md-sys-color-sidebar-background);
    box-shadow: none;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    caret-color: var(--md-sys-color-primary);
    transition: border-bottom 0.2s ease 0s, background-color 0.2s ease 0s;
    outline: none;
}

:is(.text-field).filled > :where(input, textarea) + span::after {
    content: "";
    position: absolute;
    left: 0px;
    bottom: 0px;
    display: block;
    width: 100%;
    height: 2px;
    background-color: var(--md-sys-color-primary);
    transform-origin: center bottom;
    transform: scaleX(0);
    transition: transform 0.3s ease 0s;
}

:is(.text-field).filled > :where(input, textarea):not(:focus):placeholder-shown + span {
    font-size: inherit;
    line-height: 48px;
}

:is(.text-field).filled > :where(input, textarea) + span {
    position: absolute;
    inset: 0px;
    display: block;
    box-sizing: border-box;
    padding: 7px 12px 0px;
    margin-left: 12px;
    color: var(--md-sys-color-surface-tint);
    font-size: 75%;
    line-height: 18px;
    pointer-events: none;
    transition: color 0.2s ease 0s, font-size 0.2s ease 0s, line-height 0.2s ease 0s;
}

.alert-danger {
    background-color: var(--md-sys-color-error-container) !important;
    --bs-alert-color: var(--md-sys-color-error) !important;
    --bs-alert-border-color: var(--md-sys-color-error) !important;
}


.offcanvas {
    background-color: var(--md-sys-color-sidebar-background);
    border-radius: 16px 0px 0px 16px;
    padding: 2rem;
}

.offcanvas.offcanvas-end {
    width: 800px;
}

.btn-close {
    border-radius: 16px;
    background: #f3f6fc url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/1em auto no-repeat;
}`, "",{"version":3,"sources":["webpack://./src/css/boostrap.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;AAC/B;;AAEA,gBAAgB;AAChB;IACI,4CAA4C;IAC5C,yBAAyB;AAC7B;;AAEA,iCAAiC;AACjC;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6CAA6C;AACjD;;AAEA,6BAA6B;AAC7B;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,+DAA+D;AACnE;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,6DAA6D;AACjE;;AAEA;IACI,sCAAsC;IACtC,4DAA4D;IAC5D,4DAA4D;AAChE;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sCAAsC;IACtC,4DAA4D;IAC5D,iDAAiD;IACjD,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,6CAA6C;IAC7C,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,6CAA6C;IAC7C,gDAAgD;IAChD,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;IACxC,mDAAmD;IACnD,mDAAmD;AACvD;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;IACxC,mDAAmD;IACnD,mDAAmD;IACnD,yBAAyB;AAC7B;;;AAGA;IACI,uCAAuC;IACvC,kDAAkD;IAClD,kDAAkD;AACtD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;IACvC,kDAAkD;IAClD,kDAAkD;IAClD,yBAAyB;AAC7B;;;AAGA;IACI,sCAAsC;IACtC,iDAAiD;IACjD,iDAAiD;IACjD,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sCAAsC;IACtC,iDAAiD;IACjD,iDAAiD;IACjD,yBAAyB;AAC7B;;AAEA;IACI,mEAAmE;IACnE,mEAAmE;IACnE,8DAA8D;IAC9D,0DAA0D;IAC1D,oEAAoE;IACpE,8DAA8D;AAClE;;AAEA;IACI,oEAAoE;IACpE,oEAAoE;IACpE,+DAA+D;IAC/D,2DAA2D;IAC3D,qEAAqE;IACrE,+DAA+D;AACnE;;AAEA;IACI,mEAAmE;IACnE,mEAAmE;IACnE,8DAA8D;IAC9D,0DAA0D;IAC1D,oEAAoE;IACpE,8DAA8D;AAClE;;AAEA;IACI,oEAAoE;IACpE,oEAAoE;IACpE,+DAA+D;IAC/D,2DAA2D;IAC3D,qEAAqE;IACrE,+DAA+D;AACnE;;AAEA;IACI,qEAAqE;IACrE,qEAAqE;IACrE,gEAAgE;IAChE,4DAA4D;IAC5D,sEAAsE;IACtE,gEAAgE;AACpE;;AAEA;IACI,oEAAoE;IACpE,oEAAoE;IACpE,+DAA+D;IAC/D,2DAA2D;IAC3D,qEAAqE;IACrE,+DAA+D;AACnE;;AAEA;IACI,gEAAgE;IAChE,gEAAgE;IAChE,2DAA2D;IAC3D,uDAAuD;IACvD,iEAAiE;IACjE,2DAA2D;AAC/D;;AAEA;IACI,iEAAiE;IACjE,iEAAiE;IACjE,4DAA4D;IAC5D,wDAAwD;IACxD,kEAAkE;IAClE,4DAA4D;AAChE;;AAEA;IACI,gEAAgE;IAChE,gEAAgE;IAChE,2DAA2D;IAC3D,uDAAuD;IACvD,iEAAiE;IACjE,2DAA2D;AAC/D;;AAEA;IACI,iEAAiE;IACjE,iEAAiE;IACjE,4DAA4D;IAC5D,wDAAwD;IACxD,kEAAkE;IAClE,4DAA4D;AAChE;;AAEA;IACI,kEAAkE;IAClE,kEAAkE;IAClE,6DAA6D;IAC7D,yDAAyD;IACzD,mEAAmE;IACnE,6DAA6D;AACjE;;AAEA;IACI,iEAAiE;IACjE,iEAAiE;IACjE,4DAA4D;IAC5D,wDAAwD;IACxD,kEAAkE;IAClE,4DAA4D;AAChE;;AAEA;IACI,iEAAiE;IACjE,iEAAiE;IACjE,4DAA4D;IAC5D,wDAAwD;IACxD,kEAAkE;IAClE,4DAA4D;AAChE;;AAEA;IACI,kEAAkE;IAClE,kEAAkE;IAClE,6DAA6D;IAC7D,yDAAyD;IACzD,mEAAmE;IACnE,6DAA6D;AACjE;;AAEA;IACI,iEAAiE;IACjE,iEAAiE;IACjE,4DAA4D;IAC5D,wDAAwD;IACxD,kEAAkE;IAClE,4DAA4D;AAChE;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,0DAA0D;AAC9D;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,2DAA2D;IAC3D,iEAAiE;IACjE,uDAAuD;IACvD,2DAA2D;IAC3D,gEAAgE;IAChE,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,cAAc;IACd,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,kCAAkC;IAClC,oDAAoD;IACpD,8BAA8B;IAC9B,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,mDAAmD;IACnD,wDAAwD;IACxD,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;IACpB,wCAAwC;IACxC,qEAAqE;IACrE,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,6CAA6C;IAC7C,+BAA+B;IAC/B,oBAAoB;IACpB,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,uCAAuC;IACvC,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,gFAAgF;AACpF;;AAEA;IACI,gEAAgE;IAChE,sDAAsD;IACtD,6DAA6D;AACjE;;;AAGA;IACI,wDAAwD;IACxD,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,qFAA+X;AACnY","sourcesContent":[":root {\r\n    --bs-body-font-size: 1.1rem;\r\n}\r\n\r\n/* For Firefox */\r\nhtml {\r\n    scrollbar-color: var(--md-sys-color-primary);\r\n    /*scrollbar-width: thin;*/\r\n}\r\n\r\n/* For Chrome, Edge, and Safari */\r\nbody::-webkit-scrollbar {\r\n    width: 10px;\r\n}\r\n\r\nbody::-webkit-scrollbar-track {\r\n    background-color: transparent;\r\n}\r\n\r\nbody::-webkit-scrollbar-thumb {\r\n    background-color: var(--md-sys-color-primary);\r\n}\r\n\r\n/* For horizontal scrolling */\r\n.tabbed-navigation {\r\n    overflow-x: auto;\r\n}\r\n\r\n.tabbed-navigation::-webkit-scrollbar {\r\n    height: 6px;\r\n    width: 6px;\r\n}\r\n\r\n.tabbed-navigation::-webkit-scrollbar-track {\r\n    background-color: transparent;\r\n}\r\n\r\n.tabbed-navigation::-webkit-scrollbar-thumb {\r\n    background-color: var(--md-sys-color-primary);\r\n}\r\n\r\na {\r\n    color: var(--md-sys-color-on-surface-variant);\r\n}\r\n\r\na, a:hover {\r\n    text-decoration: none\r\n}\r\n\r\na:hover {\r\n    color: var(--md-sys-color-on-surface);\r\n}\r\n\r\n.link-no-style:hover {\r\n    text-decoration: none;\r\n    color: var(--md-sys-color-on-surface-variant)\r\n}\r\n\r\n.dropdown-item {\r\n    font-family: 'ProductSans-Small', Arial, Helvetica, sans-serif;\r\n}\r\n\r\np, a, li {\r\n    font-family: 'ProductSans-Small', Arial, Helvetica, sans-serif;\r\n}\r\n\r\n.nav-item a, .tab-label {\r\n    font-family: 'ProductSans-Medium', Arial, Helvetica, sans-serif;\r\n}\r\n\r\nsection {\r\n    padding-right: 3rem;\r\n    padding-left: 3rem;\r\n}\r\n\r\nul > li {\r\n    margin-bottom: 13px;\r\n}\r\n\r\n.btn {\r\n    padding: 0.7rem 1.2rem;\r\n    border-radius: 20px;\r\n    font-family: 'ProductSans-Bold', Arial, Helvetica, sans-serif;\r\n}\r\n\r\n.btn-landing {\r\n    color: var(--md-sys-color-landing-btn);\r\n    background-color: var(--md-sys-color-landing-btn-background);\r\n    border: 2px solid var(--md-sys-color-landing-btn-background);\r\n}\r\n\r\n.btn-landing:not(:hover) {\r\n    transition-duration: 0.4s;\r\n}\r\n\r\n.btn-landing:hover, .btn-landing:focus, .btn-landing.focus {\r\n    color: var(--md-sys-color-landing-btn);\r\n    background-color: var(--md-sys-color-landing-btn-background);\r\n    border: 2px solid var(--md-sys-color-landing-btn);\r\n    transition-duration: 0.6s;\r\n}\r\n\r\n.btn-primary {\r\n    color: var(--md-sys-color-on-primary);\r\n    background-color: var(--md-sys-color-primary);\r\n    border: 2px solid var(--md-sys-color-primary);\r\n}\r\n\r\n.btn-primary:not(:hover) {\r\n    transition-duration: 0.4s;\r\n}\r\n\r\n.btn-primary:hover, .btn-primary:focus, .btn-primary.focus {\r\n    color: var(--md-sys-color-on-primary);\r\n    background-color: var(--md-sys-color-primary);\r\n    border: 2px solid var(--md-sys-color-on-primary);\r\n    transition-duration: 0.6s;\r\n}\r\n\r\n.btn-secondary {\r\n    color: var(--md-ref-palette-secondary30);\r\n    background-color: var(--md-ref-palette-secondary90);\r\n    border: 2px solid var(--md-ref-palette-secondary90);\r\n}\r\n\r\n\r\n.btn-secondary:not(:hover) {\r\n    transition-duration: 0.4s;\r\n}\r\n\r\n.btn-secondary:hover, .btn-secondary:focus, .btn-secondary.focus {\r\n    color: var(--md-ref-palette-secondary30);\r\n    background-color: var(--md-ref-palette-secondary90);\r\n    border: 2px solid var(--md-ref-palette-secondary30);\r\n    transition-duration: 0.6s;\r\n}\r\n\r\n\r\n.btn-tertiary {\r\n    color: var(--md-ref-palette-tertiary30);\r\n    background-color: var(--md-ref-palette-tertiary90);\r\n    border: 2px solid var(--md-ref-palette-tertiary90);\r\n}\r\n\r\n.btn-tertiary:not(:hover) {\r\n    transition-duration: 0.4s;\r\n}\r\n\r\n.btn-tertiary:hover, .btn-tertiary:focus, .btn-tertiary.focus {\r\n    color: var(--md-ref-palette-tertiary30);\r\n    background-color: var(--md-ref-palette-tertiary90);\r\n    border: 2px solid var(--md-ref-palette-tertiary30);\r\n    transition-duration: 0.6s;\r\n}\r\n\r\n\r\n.btn-neutral {\r\n    color: var(--md-ref-palette-neutral30);\r\n    background-color: var(--md-ref-palette-neutral90);\r\n    border: 2px solid var(--md-ref-palette-neutral30);\r\n    border-radius: 15px;\r\n    font-weight: 600;\r\n}\r\n\r\n.btn-neutral:not(:hover) {\r\n    transition-duration: 0.4s;\r\n}\r\n\r\n.btn-neutral:hover, .btn-neutral:focus, .btn-neutral.focus {\r\n    color: var(--md-ref-palette-neutral30);\r\n    background-color: var(--md-ref-palette-neutral90);\r\n    border: 2px solid var(--md-ref-palette-neutral30);\r\n    transition-duration: 0.6s;\r\n}\r\n\r\n.display-large {\r\n    font-family: var(--md-sys-typescale-display-large-font-family-name);\r\n    font-style: var(--md-sys-typescale-display-large-font-family-style);\r\n    font-weight: var(--md-sys-typescale-display-large-font-weight);\r\n    font-size: var(--md-sys-typescale-display-large-font-size);\r\n    letter-spacing: var(--md-sys-typescale-display-large-letter-spacing);\r\n    line-height: var(--md-sys-typescale-display-large-line-height);\r\n}\r\n\r\n.display-medium {\r\n    font-family: var(--md-sys-typescale-display-medium-font-family-name);\r\n    font-style: var(--md-sys-typescale-display-medium-font-family-style);\r\n    font-weight: var(--md-sys-typescale-display-medium-font-weight);\r\n    font-size: var(--md-sys-typescale-display-medium-font-size);\r\n    letter-spacing: var(--md-sys-typescale-display-medium-letter-spacing);\r\n    line-height: var(--md-sys-typescale-display-medium-line-height);\r\n}\r\n\r\n.display-small {\r\n    font-family: var(--md-sys-typescale-display-small-font-family-name);\r\n    font-style: var(--md-sys-typescale-display-small-font-family-style);\r\n    font-weight: var(--md-sys-typescale-display-small-font-weight);\r\n    font-size: var(--md-sys-typescale-display-small-font-size);\r\n    letter-spacing: var(--md-sys-typescale-display-small-letter-spacing);\r\n    line-height: var(--md-sys-typescale-display-small-line-height);\r\n}\r\n\r\n.headline-large {\r\n    font-family: var(--md-sys-typescale-headline-large-font-family-name);\r\n    font-style: var(--md-sys-typescale-headline-large-font-family-style);\r\n    font-weight: var(--md-sys-typescale-headline-large-font-weight);\r\n    font-size: var(--md-sys-typescale-headline-large-font-size);\r\n    letter-spacing: var(--md-sys-typescale-headline-large-letter-spacing);\r\n    line-height: var(--md-sys-typescale-headline-large-line-height);\r\n}\r\n\r\n.headline-medium {\r\n    font-family: var(--md-sys-typescale-headline-medium-font-family-name);\r\n    font-style: var(--md-sys-typescale-headline-medium-font-family-style);\r\n    font-weight: var(--md-sys-typescale-headline-medium-font-weight);\r\n    font-size: var(--md-sys-typescale-headline-medium-font-size);\r\n    letter-spacing: var(--md-sys-typescale-headline-medium-letter-spacing);\r\n    line-height: var(--md-sys-typescale-headline-medium-line-height);\r\n}\r\n\r\n.headline-small {\r\n    font-family: var(--md-sys-typescale-headline-small-font-family-name);\r\n    font-style: var(--md-sys-typescale-headline-small-font-family-style);\r\n    font-weight: var(--md-sys-typescale-headline-small-font-weight);\r\n    font-size: var(--md-sys-typescale-headline-small-font-size);\r\n    letter-spacing: var(--md-sys-typescale-headline-small-letter-spacing);\r\n    line-height: var(--md-sys-typescale-headline-small-line-height);\r\n}\r\n\r\n.body-large {\r\n    font-family: var(--md-sys-typescale-body-large-font-family-name);\r\n    font-style: var(--md-sys-typescale-body-large-font-family-style);\r\n    font-weight: var(--md-sys-typescale-body-large-font-weight);\r\n    font-size: var(--md-sys-typescale-body-large-font-size);\r\n    letter-spacing: var(--md-sys-typescale-body-large-letter-spacing);\r\n    line-height: var(--md-sys-typescale-body-large-line-height);\r\n}\r\n\r\n.body-medium {\r\n    font-family: var(--md-sys-typescale-body-medium-font-family-name);\r\n    font-style: var(--md-sys-typescale-body-medium-font-family-style);\r\n    font-weight: var(--md-sys-typescale-body-medium-font-weight);\r\n    font-size: var(--md-sys-typescale-body-medium-font-size);\r\n    letter-spacing: var(--md-sys-typescale-body-medium-letter-spacing);\r\n    line-height: var(--md-sys-typescale-body-medium-line-height);\r\n}\r\n\r\n.body-small {\r\n    font-family: var(--md-sys-typescale-body-small-font-family-name);\r\n    font-style: var(--md-sys-typescale-body-small-font-family-style);\r\n    font-weight: var(--md-sys-typescale-body-small-font-weight);\r\n    font-size: var(--md-sys-typescale-body-small-font-size);\r\n    letter-spacing: var(--md-sys-typescale-body-small-letter-spacing);\r\n    line-height: var(--md-sys-typescale-body-small-line-height);\r\n}\r\n\r\n.label-large {\r\n    font-family: var(--md-sys-typescale-label-large-font-family-name);\r\n    font-style: var(--md-sys-typescale-label-large-font-family-style);\r\n    font-weight: var(--md-sys-typescale-label-large-font-weight);\r\n    font-size: var(--md-sys-typescale-label-large-font-size);\r\n    letter-spacing: var(--md-sys-typescale-label-large-letter-spacing);\r\n    line-height: var(--md-sys-typescale-label-large-line-height);\r\n}\r\n\r\n.label-medium {\r\n    font-family: var(--md-sys-typescale-label-medium-font-family-name);\r\n    font-style: var(--md-sys-typescale-label-medium-font-family-style);\r\n    font-weight: var(--md-sys-typescale-label-medium-font-weight);\r\n    font-size: var(--md-sys-typescale-label-medium-font-size);\r\n    letter-spacing: var(--md-sys-typescale-label-medium-letter-spacing);\r\n    line-height: var(--md-sys-typescale-label-medium-line-height);\r\n}\r\n\r\n.label-small {\r\n    font-family: var(--md-sys-typescale-label-small-font-family-name);\r\n    font-style: var(--md-sys-typescale-label-small-font-family-style);\r\n    font-weight: var(--md-sys-typescale-label-small-font-weight);\r\n    font-size: var(--md-sys-typescale-label-small-font-size);\r\n    letter-spacing: var(--md-sys-typescale-label-small-letter-spacing);\r\n    line-height: var(--md-sys-typescale-label-small-line-height);\r\n}\r\n\r\n.title-large {\r\n    font-family: var(--md-sys-typescale-title-large-font-family-name);\r\n    font-style: var(--md-sys-typescale-title-large-font-family-style);\r\n    font-weight: var(--md-sys-typescale-title-large-font-weight);\r\n    font-size: var(--md-sys-typescale-title-large-font-size);\r\n    letter-spacing: var(--md-sys-typescale-title-large-letter-spacing);\r\n    line-height: var(--md-sys-typescale-title-large-line-height);\r\n}\r\n\r\n.title-medium {\r\n    font-family: var(--md-sys-typescale-title-medium-font-family-name);\r\n    font-style: var(--md-sys-typescale-title-medium-font-family-style);\r\n    font-weight: var(--md-sys-typescale-title-medium-font-weight);\r\n    font-size: var(--md-sys-typescale-title-medium-font-size);\r\n    letter-spacing: var(--md-sys-typescale-title-medium-letter-spacing);\r\n    line-height: var(--md-sys-typescale-title-medium-line-height);\r\n}\r\n\r\n.title-small {\r\n    font-family: var(--md-sys-typescale-title-small-font-family-name);\r\n    font-style: var(--md-sys-typescale-title-small-font-family-style);\r\n    font-weight: var(--md-sys-typescale-title-small-font-weight);\r\n    font-size: var(--md-sys-typescale-title-small-font-size);\r\n    letter-spacing: var(--md-sys-typescale-title-small-letter-spacing);\r\n    line-height: var(--md-sys-typescale-title-small-line-height);\r\n}\r\n\r\n.primary {\r\n    background-color: var(--md-sys-color-primary);\r\n}\r\n\r\n.primary-text {\r\n    color: var(--md-sys-color-primary);\r\n}\r\n\r\n.on-primary {\r\n    background-color: var(--md-sys-color-on-primary);\r\n}\r\n\r\n.on-primary-text {\r\n    color: var(--md-sys-color-on-primary);\r\n}\r\n\r\n.primary-container {\r\n    background-color: var(--md-sys-color-primary-container);\r\n}\r\n\r\n.primary-container-text {\r\n    color: var(--md-sys-color-primary-container);\r\n}\r\n\r\n.on-primary-container {\r\n    background-color: var(--md-sys-color-on-primary-container);\r\n}\r\n\r\n.on-primary-container-text {\r\n    color: var(--md-sys-color-on-primary-container);\r\n}\r\n\r\n.secondary {\r\n    background-color: var(--md-sys-color-secondary);\r\n}\r\n\r\n.secondary-text {\r\n    color: var(--md-sys-color-secondary);\r\n}\r\n\r\n.on-secondary {\r\n    background-color: var(--md-sys-color-on-secondary);\r\n}\r\n\r\n.on-secondary-text {\r\n    color: var(--md-sys-color-on-secondary);\r\n}\r\n\r\n.secondary-container {\r\n    background-color: var(--md-sys-color-secondary-container);\r\n}\r\n\r\n.secondary-container-text {\r\n    color: var(--md-sys-color-secondary-container);\r\n}\r\n\r\n.on-secondary-container {\r\n    background-color: var(--md-sys-color-on-secondary-container);\r\n}\r\n\r\n.on-secondary-container-text {\r\n    color: var(--md-sys-color-on-secondary-container);\r\n}\r\n\r\n.tertiary {\r\n    background-color: var(--md-sys-color-tertiary);\r\n}\r\n\r\n.tertiary-text {\r\n    color: var(--md-sys-color-tertiary);\r\n}\r\n\r\n.on-tertiary {\r\n    background-color: var(--md-sys-color-on-tertiary);\r\n}\r\n\r\n.on-tertiary-text {\r\n    color: var(--md-sys-color-on-tertiary);\r\n}\r\n\r\n.tertiary-container {\r\n    background-color: var(--md-sys-color-tertiary-container);\r\n}\r\n\r\n.tertiary-container-text {\r\n    color: var(--md-sys-color-tertiary-container);\r\n}\r\n\r\n.on-tertiary-container {\r\n    background-color: var(--md-sys-color-on-tertiary-container);\r\n}\r\n\r\n.on-tertiary-container-text {\r\n    color: var(--md-sys-color-on-tertiary-container);\r\n}\r\n\r\n.error {\r\n    background-color: var(--md-sys-color-error);\r\n}\r\n\r\n.error-text {\r\n    color: var(--md-sys-color-error);\r\n}\r\n\r\n.error-container {\r\n    background-color: var(--md-sys-color-error-container);\r\n}\r\n\r\n.error-container-text {\r\n    color: var(--md-sys-color-error-container);\r\n}\r\n\r\n.on-error {\r\n    background-color: var(--md-sys-color-on-error);\r\n}\r\n\r\n.on-error-text {\r\n    color: var(--md-sys-color-on-error);\r\n}\r\n\r\n.on-error-container {\r\n    background-color: var(--md-sys-color-on-error-container);\r\n}\r\n\r\n.on-error-container-text {\r\n    color: var(--md-sys-color-on-error-container);\r\n}\r\n\r\n.background {\r\n    background-color: var(--md-sys-color-background);\r\n}\r\n\r\n.background-text {\r\n    color: var(--md-sys-color-background);\r\n}\r\n\r\n.on-background {\r\n    background-color: var(--md-sys-color-on-background);\r\n}\r\n\r\n.on-background-text {\r\n    color: var(--md-sys-color-on-background);\r\n}\r\n\r\n.surface {\r\n    background-color: var(--md-sys-color-surface);\r\n}\r\n\r\n.surface-text {\r\n    color: var(--md-sys-color-surface);\r\n}\r\n\r\n.on-surface {\r\n    background-color: var(--md-sys-color-on-surface);\r\n}\r\n\r\n.on-surface-text {\r\n    color: var(--md-sys-color-on-surface);\r\n}\r\n\r\n.surface-variant {\r\n    background-color: var(--md-sys-color-surface-variant);\r\n}\r\n\r\n.surface-variant-text {\r\n    color: var(--md-sys-color-surface-variant);\r\n}\r\n\r\n.on-surface-variant {\r\n    background-color: var(--md-sys-color-on-surface-variant);\r\n}\r\n\r\n.on-surface-variant-text {\r\n    color: var(--md-sys-color-on-surface-variant);\r\n}\r\n\r\n.outline {\r\n    background-color: var(--md-sys-color-outline);\r\n}\r\n\r\n.outline-text {\r\n    color: var(--md-sys-color-outline);\r\n}\r\n\r\n.inverse-on-surface {\r\n    background-color: var(--md-sys-color-inverse-on-surface);\r\n}\r\n\r\n.inverse-on-surface-text {\r\n    color: var(--md-sys-color-inverse-on-surface);\r\n}\r\n\r\n.inverse-surface {\r\n    background-color: var(--md-sys-color-inverse-surface);\r\n}\r\n\r\n.inverse-surface-text {\r\n    color: var(--md-sys-color-inverse-surface);\r\n}\r\n\r\n.inverse-primary {\r\n    background-color: var(--md-sys-color-inverse-primary);\r\n}\r\n\r\n.inverse-primary-text {\r\n    color: var(--md-sys-color-inverse-primary);\r\n}\r\n\r\n.shadow {\r\n    background-color: var(--md-sys-color-shadow);\r\n}\r\n\r\n.shadow-text {\r\n    color: var(--md-sys-color-shadow);\r\n}\r\n\r\n.surface-tint {\r\n    background-color: var(--md-sys-color-surface-tint);\r\n}\r\n\r\n.surface-tint-text {\r\n    color: var(--md-sys-color-surface-tint);\r\n}\r\n\r\n.outline-variant {\r\n    background-color: var(--md-sys-color-outline-variant);\r\n}\r\n\r\n.outline-variant-text {\r\n    color: var(--md-sys-color-outline-variant);\r\n}\r\n\r\n.scrim {\r\n    background-color: var(--md-sys-color-scrim);\r\n}\r\n\r\n.scrim-text {\r\n    color: var(--md-sys-color-scrim);\r\n}\r\n\r\n:is(.text-field) {\r\n    line-height: var(--md-sys-typescale-body-large-line-height);\r\n    letter-spacing: var(--md-sys-typescale-body-large-letter-spacing);\r\n    font-size: var(--md-sys-typescale-body-large-font-size);\r\n    font-weight: var(--md-sys-typescale-body-large-font-weight);\r\n    font-family: var(--md-sys-typescale-body-large-font-family-name);\r\n    position: relative;\r\n    display: inline-block;\r\n    overflow: hidden;\r\n}\r\n\r\n\r\n:where(input, textarea):not(:focus)::placeholder {\r\n    color: transparent;\r\n}\r\n\r\n.text-field:is(:focus)::placeholder {\r\n    color: grey;\r\n}\r\n\r\n:is(.text-field).filled > :where(input, textarea) {\r\n\r\n    display: block;\r\n    box-sizing: border-box;\r\n    margin: 0px;\r\n    border-right: none;\r\n    border-left: none;\r\n    border-image: initial;\r\n    border-top: 27px solid transparent;\r\n    border-bottom: solid 1px var(--md-sys-color-primary);\r\n    border-radius: 4px 4px 0px 0px;\r\n    padding: 0px 12px 10px;\r\n    width: 100%;\r\n    height: inherit;\r\n    color: rgb(var(--md-sys-color-surface-tint) / 0.87);\r\n    background-color: var(--md-sys-color-sidebar-background);\r\n    box-shadow: none;\r\n    font-family: inherit;\r\n    font-size: inherit;\r\n    line-height: inherit;\r\n    caret-color: var(--md-sys-color-primary);\r\n    transition: border-bottom 0.2s ease 0s, background-color 0.2s ease 0s;\r\n    outline: none;\r\n}\r\n\r\n:is(.text-field).filled > :where(input, textarea) + span::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 0px;\r\n    bottom: 0px;\r\n    display: block;\r\n    width: 100%;\r\n    height: 2px;\r\n    background-color: var(--md-sys-color-primary);\r\n    transform-origin: center bottom;\r\n    transform: scaleX(0);\r\n    transition: transform 0.3s ease 0s;\r\n}\r\n\r\n:is(.text-field).filled > :where(input, textarea):not(:focus):placeholder-shown + span {\r\n    font-size: inherit;\r\n    line-height: 48px;\r\n}\r\n\r\n:is(.text-field).filled > :where(input, textarea) + span {\r\n    position: absolute;\r\n    inset: 0px;\r\n    display: block;\r\n    box-sizing: border-box;\r\n    padding: 7px 12px 0px;\r\n    margin-left: 12px;\r\n    color: var(--md-sys-color-surface-tint);\r\n    font-size: 75%;\r\n    line-height: 18px;\r\n    pointer-events: none;\r\n    transition: color 0.2s ease 0s, font-size 0.2s ease 0s, line-height 0.2s ease 0s;\r\n}\r\n\r\n.alert-danger {\r\n    background-color: var(--md-sys-color-error-container) !important;\r\n    --bs-alert-color: var(--md-sys-color-error) !important;\r\n    --bs-alert-border-color: var(--md-sys-color-error) !important;\r\n}\r\n\r\n\r\n.offcanvas {\r\n    background-color: var(--md-sys-color-sidebar-background);\r\n    border-radius: 16px 0px 0px 16px;\r\n    padding: 2rem;\r\n}\r\n\r\n.offcanvas.offcanvas-end {\r\n    width: 800px;\r\n}\r\n\r\n.btn-close {\r\n    border-radius: 16px;\r\n    background: #f3f6fc url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e\") center/1em auto no-repeat;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
